export default "__VITE_ASSET__806f6f56__"